/* src/app/private/components/leads/move-lead-space/move-lead-space.component.scss */
label {
  font-weight: 500;
  margin-bottom: 5px;
}
/*# sourceMappingURL=move-lead-space.component.css.map */
